import React, { useEffect, useMemo, useState } from 'react';
import { CloseButton } from 'react-bootstrap';

import { useLocalization } from '../contexts/LocalizationContext';
import { useApi } from '../hooks/useApi';
import { useAuth } from '../contexts/AuthContext';

const levelClassByLevel = {
  info: 'system-message-banner-info',
  warning: 'system-message-banner-warning',
  danger: 'system-message-banner-danger'
};

export default function SystemMessageBanner() {
  const { isLoggedIn, selectedTenant, role } = useAuth();
  const { localize } = useLocalization();
  const [dismissedIds, setDismissedIds] = useState([]);

  const { data: messages = [], fetch } = useApi('/system-messages', {
    fetchOnMount: false,
    initialState: []
  });

  useEffect(() => {
    if (!isLoggedIn || !selectedTenant || !role) return;
    fetch();
    setDismissedIds([]);
  }, [isLoggedIn, selectedTenant?.id, role]);

  const visibleMessages = useMemo(() => {
    return messages.filter((message) => !dismissedIds.includes(message.id));
  }, [messages, dismissedIds]);

  if (!isLoggedIn || !visibleMessages.length) {
    return null;
  }

  return (
    <div className='system-message-banner-stack'>
      {visibleMessages.map((message) => (
        <div
          key={message.id}
          className={`system-message-banner ${
            levelClassByLevel[message.level] || levelClassByLevel.info
          }`}>
          <CloseButton
            onClick={() =>
              setDismissedIds((prev) => prev.concat(message.id))
            }
            className='system-message-banner-close'
          />
          <div className='system-message-banner-content'>
            <div className='system-message-banner-title'>
              {localize(message.title)}
            </div>
            <div
              className='system-message-banner-body'
              dangerouslySetInnerHTML={{
                __html: localize(message.body || '')
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
